import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';

var script = defineComponent({
    name: 'ItineraryFlowProcedureInstructions',
    components: {
        BasicCard: __vue_component__,
    },
    props: {
        procedureID: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const { procedures } = usePortalStore();
        const procedure = computed(() => procedures.get(props.procedureID));
        const prescriberID = computed(() => { var _a, _b; return (_b = (_a = procedure.value) === null || _a === void 0 ? void 0 : _a.computed.prescriberID) !== null && _b !== void 0 ? _b : null; });
        const instructions = computed(() => { var _a; return (_a = procedure.value) === null || _a === void 0 ? void 0 : _a.computed.nurseInstructions; });
        return {
            instructions,
            prescriberID,
        };
    },
});

export { script as default };
